<template>
  <span class="ps-1">
    <a :href="createLink()" target="_blank">
      <svg class="bi" :class="'text-' + color" width="18" height="18" fill="currentColor">
        <use xlink:href="@/assets/icons/icons.svg#info-circle"/>
      </svg>
    </a>
  </span>
</template>

<script>
export default {
  name: 'DocsInfoLink',
  props: ['color', 'target'],
  data () {
    return {
      targets: {
        // Strategien und Ziele
        manageVisions: {
          de: 'docs/strategies#leitbild',
          en: 'en/docs/strategies#mission-statement'
        },
        manageStrategies: {
          de: 'docs/strategies#Strategieübersicht',
          en: 'en/docs/strategies#strategy-overview'
        },
        createStrategy: {
          de: 'docs/strategies#strategiefeld-erstellen',
          en: 'en/docs/strategies#create-strategy'
        },
        viewObjective: {
          de: 'docs/objectives#zielübersicht',
          en: 'en/docs/objectives#objectives-overview'
        },
        createObjective: {
          de: 'docs/objectives#ziel-erstellen',
          en: 'en/docs/objectives#create-objective'
        },
        viewXmatrix: {
          de: 'docs/objectives#x-matrix-anzeigen',
          en: 'en/docs/objectives#view-x-matrix'
        },

        // Monitoring
        cockpit: {
          de: 'docs/monitoring#cockpit',
          en: 'en/docs/monitoring#cockpit'
        },
        viewKPIs: {
          de: 'docs/monitoring#kpi-daten-anzeigen',
          en: 'en/docs/monitoring#display-kpis'
        },
        createKPI: {
          de: 'docs/monitoring#kpi-erstellen',
          en: 'en/docs/monitoring#create-kpi'
        },
        manageKPIs: {
          de: 'docs/monitoring#kpis-verwalten',
          en: 'en/docs/monitoring#manage-kpis'
        },
        manageKPIRecordActual: {
          de: 'docs/monitoring#ist-und-forecastwerte-erfassen',
          en: 'en/docs/monitoring#entering-actual-and-forecast-values'
        },
        manageKPIRecordPlan: {
          de: 'docs/monitoring#planwerte-erfassen',
          en: 'en/docs/monitoring#entering-planned-values'
        },
        manageKPIRecordObjective: {
          de: 'docs/objectives#zielwerte-erfassen',
          en: 'en/docs/objectives#entering-objective-values'
        },
        manageKPISets: {
          de: 'docs/monitoring#kpi-sets-verwalten',
          en: 'en/docs/monitoring#manage-kpi-sets'
        },
        kpiDeviation: {
          de: 'docs/monitoring#abweichungen-analysieren',
          en: 'en/docs/monitoring#analyze-deviations'
        },
        kpiChange: {
          de: 'docs/monitoring#veränderungen-analysieren',
          en: 'en/docs/monitoring#analyze-changes'
        },

        // Projekte
        createProject: {
          de: 'docs/projects#projekt-erstellen',
          en: 'en/docs/projects#create-project'
        },
        manageProjects: {
          de: 'docs/projects',
          en: 'en/docs/projects'
        },

        // Organisation
        createOrg: {
          de: 'docs/organization#org-einheit-erstellen',
          en: 'en/docs/organization#create-org-unit'
        },
        viewOrg: {
          de: 'docs/organization#organisationsübersicht',
          en: 'en/docs/organization#organization-overview'
        },
        manageEmployees: {
          de: 'docs/organization#mitarbeiter-verwalten',
          en: 'en/docs/organization#manage-employees'
        },

        // My
        my: {
          de: 'docs/my',
          en: 'en/docs/my'
        },

        // Einstellungen und Account
        managePermissions: {
          de: 'docs/settings#berechtigungen-verwalten',
          en: 'en/docs/settings#manage-authorisations'
        },
        manageSettings: {
          de: 'docs/settings',
          en: 'en/docs/settings'
        },
        manageAccount: {
          de: 'docs/account',
          en: 'en/docs/account'
        },
        downloadDocuments: {
          de: 'docs/account',
          en: 'en/docs/account'
        }
      }
    }
  },
  computed: {
    isDE () {
      return this.$store.state.user.settings.language?.includes('de')
    }
  },
  methods: {
    createLink () {
      const baseUrl = 'https://focusmt.de/'
      try { return this.isDE ? baseUrl + this.targets[this.target].de : baseUrl + this.targets[this.target].en } catch (e) {}
    }
  }
}
</script>

<style>
svg {
  margin-top: -2px;
}
</style>
